import service from '@/utils/request'; // getSpecialOrderList 获取特殊结算审批列表
// @Tags orderManage
// @Summary 分页获取特殊结算审批列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取获取特殊结算审批列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/special/getList [get]

export var getSpecialOrderAuditList = function getSpecialOrderAuditList(params) {
  return service({
    url: '/orderManage/special/getList',
    method: 'get',
    params: params
  });
}; // bairunSpecialOrderCheck 特殊结算审批
// @Tags orderManage
// @Summary 特殊结算审批
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "特殊结算审批"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /orderManage/special/check [post]

export var bairunSpecialOrderCheck = function bairunSpecialOrderCheck(data) {
  return service({
    url: '/orderManage/special/check',
    method: 'post',
    data: data
  });
}; // getRefundOrderList 获取退款审批列表
// @Tags orderManage
// @Summary 分页获取退款审批列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取退款审批列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/refund/getList [get]

export var getRefundOrderList = function getRefundOrderList(params) {
  return service({
    url: '/orderManage/refund/getList',
    method: 'get',
    params: params
  });
}; // bairunRefundOrderCheck 退款审批
// @Tags orderManage
// @Summary 退款审批
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "退款审批"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /orderManage/refund/check [post]

export var bairunRefundOrderCheck = function bairunRefundOrderCheck(data) {
  return service({
    url: '/orderManage/refund/check',
    method: 'post',
    data: data
  });
}; // getRefundOrderList 获取补卡审批列表
// @Tags orderManage
// @Summary 分页获取补卡审批列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取补卡审批列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/refund/getList [get]

export var getChangecardList = function getChangecardList(params) {
  return service({
    url: '/svcManage/svcBalance/changecard/getList',
    method: 'get',
    params: params
  });
}; // bairunRefundOrderCheck 补卡审批
// @Tags orderManage
// @Summary 补卡审批
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "补卡审批"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /orderManage/refund/check [post]

export var bairunChangecardCheck = function bairunChangecardCheck(data) {
  return service({
    url: '/svcManage/svcBalance/changecard/submit',
    method: 'post',
    data: data
  });
};